export enum DrivingButtonStates {
  TURNED_OFF = "TURNED_OFF",
  READY = "READY",
  DRIVE = "DRIVE",
  ERROR = "ERROR",
  SWITCHING = "SWITCHING",
}
